import { Score } from '@components/HierarchicalTable/TSAdvancedHierarchicalTable';
import { ReportTreeNode } from '../../types';

/**
 * Creates a hierarchical score structure from a skill tree node.
 * Uses robust null handling to filter out invalid nodes.
 */
export const createHierarchicalScore = (
  node: ReportTreeNode | undefined,
  studentReport: any,
): Score | null => {
  if (!node || !node.id) {
    return null;
  }
  const nodeScore = studentReport?.[node.id];
  let averageScore = 0;
  if (
    nodeScore &&
    Number.isFinite(nodeScore.score) &&
    Number.isFinite(nodeScore.max_score) &&
    nodeScore.max_score > 0
  ) {
    averageScore = (nodeScore.score / nodeScore.max_score) * 100;
  }

  const subScores =
    node.subNodes
      ?.map((subNode: ReportTreeNode) => createHierarchicalScore(subNode, studentReport))
      .filter((score): score is Score => score !== null) || [];

  return {
    id: node.id,
    averageScore,
    subScores: subScores.length > 0 ? subScores : undefined,
  };
};
